<template>
    <main>
        <!-- 导航 -->
        <navbar active="2" @changeTab="changeTab"></navbar>
        <!-- 中间内容区域 -->
        <div class="bui-container-question" :class="{jp: $region === 'jp', en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi'}">
            <!-- 顶部公告 -->
            <template v-if="$region=='jp'">
                <div class="remind1" v-html="$t('service.replyProblems1')"></div>
                <div class="remind1 remind2" v-html="$t('service.replyProblems2')"></div>
            </template>
            <template v-else>
                <div class="notice">
                    <img src="../images/smile.svg"/>
                    <span>{{$t('service.replyProblems')}}</span>
                </div>
            </template>
            <!--暱稱-->
            <!-- <input-box class="input-box" title="賬號" placeholder="" v-model="account.nickName" readonly="true"></input-box> -->
            <p class="title">{{$t('service.uname')}}</p>
            <input class="nick-box" :value="userInfo.nickName" readonly disabled="disabled"/>
            <!--遊戲-->
            <p class="title">{{$t('service.game')}}</p>
            <select-box ref="selectGame" class="select-box" :options="gameList" :id="formData.game_base_id"
                        :placeholder="$t('service.needAskGame')" @selectOption="selectGameId">
            </select-box>
            <p class="error-info" v-show="errorInfo.game_base_id != ''">{{errorInfo.game_base_id}}</p>
            <!--問題類型-->
            <p class="title">{{$t('service.questionsType')}}</p>
            <select-box ref="selectType" class="select-box" :options="typeList"
                        :placeholder="$t('service.choseRelevantQuestionType')" @selectOption="selectType">
            </select-box>
            <p class="error-info" v-show="errorInfo.question_type != ''">{{errorInfo.question_type}}</p>
            <!--角色ID-->
            <input-box class="input-box" v-model="formData.character_id" :errMsg="errorInfo.character_id"
                       @blur="vartify('character_id')" :title="$t('service.roleId')"
                       :placeholder="$t('service.writeRoleId')"></input-box>
            <p class="error-info" v-show="errorInfo.character_id != ''">{{errorInfo.character_id}}</p>
            <!--角色名稱-->
            <input-box class="input-box" v-model="formData.character_name" :errMsg="errorInfo.character_name"
                       @blur="vartify('character_name')" :title="$t('service.roleName')"
                       :placeholder="$t('service.writeRoleName')"></input-box>
            <p class="error-info" v-show="errorInfo.character_name != ''">{{errorInfo.character_name}}</p>
            <!--聯繫EMAIL-->
            <input-box v-if="$region !== 'jp'" class="input-box" v-model="formData.email" :errMsg="errorInfo.email" @blur="vartify('email')"
                       :title="$t('service.toEmail')" :placeholder="$t('service.writeUserEmail')">
            
                <span>*{{$t('service.writeEmailGetNews')}}</span>
            </input-box>
            <input-box v-if="$region === 'jp'" class="input-box" v-model="formData.email" :errMsg="errorInfo.email" @blur="vartify('email', 'no')"
                       :title="$t('service.toEmail')" :placeholder="$t('service.writeUserEmail')">
            </input-box>
            <p class="error-info" v-show="errorInfo.email != ''">{{errorInfo.email}}</p>
            <!--設定Line Notify-->
            <!-- <p class="title">設定Line Notify</p>
                                                                                                                                        <select-box class="select-box" placeholder="設定Line Notify" @selectOption="selectGameId" width="300px" height="50px">
                                                                                                                                        </select-box> -->
            <!--問題標題-->
            <input-box class="input-box" v-model="formData.question_title" :errMsg="errorInfo.question_title"
                       @blur="vartify('question_title')" :title="$t('service.questionsTitle')"
                       :placeholder="$t('service.writeQuestionType')"></input-box>
            <p class="error-info" v-show="errorInfo.question_title != ''">{{errorInfo.question_title}}</p>
            <!--問題內容或建議-->
            <p class="title">{{$t('service.questionsContent')}}</p>
            <textarea :class="{'error': errorInfo.question_content != ''}" v-model="formData.question_content"
                      :placeholder="$t('service.writeQuestionContent')" @blur="vartify('question_content')"
                      maxlength="1000"></textarea>
            <p class="error-info" v-show="errorInfo.question_content != ''">{{errorInfo.question_content}}</p>
            <!--選擇檔案-->
            <p class="title">{{$t('service.choseRecord')}}<span>{{$t('service.vaildUploadFile')}}</span>
            </p>
            <div class="img-box">
                <div class="imgInput" v-for="i in ['p1','p2','p3']" :key="i">
                    <div class="previewImg" :class="{on: delFlag[i]}" v-if="receiveKeyVal[i] != ''"
                         @click.stop.prevent="delImg(i)" @mouseover.stop.prevent="showPreImg(i)"
                         @mouseout.stop.prevent="closePreImg(i)" :style="{backgroundImage:'url('+receiveKeyVal[i]+')'}">
                        <div class="btn-del">
                            <img src="../images/delete.svg" v-if="delFlag[i]"/>
                        </div>
                    </div>
                    <div class="file_btn" v-else>
                        <div class="loadingImg" v-if="loadingFlag[i]"></div>
                        <input type="file" name="file" @change="uploadChange($event, i)" accept="image/*">
                    </div>
                </div>
                <!-- 预览大图模式 -->
                <div ref="preImg" class="big-img" v-show="showImg"></div>
            </div>
            <!-- 分割线 -->
            <hr>
            <!-- 確認送出 -->
            <div class="btn-submit" @click="submitForm()" :class="{active: canSubmit}" ga-data="1901001">
                {{$t('service.sureSent')}}
            </div>
        </div>
    </main>
</template>

<script>
    import navbar from "./component/navbar";
    import inputBox from "./component/input";
    import selectBox from "./component/select";

    import { mapGetters } from "vuex";

    export default {
        name: "index",
        data() {
            return {
                showImg: false,
                formData: {
                    game_base_id: "",
                    character_id: "",
                    character_name: "",
                    email: "",
                    question_type: "",
                    question_title: "",
                    question_content: "",
                    attachments: [],
                    source: "web"
                },
                gameList: [],
                typeList: [],
                errorInfo: {
                    game_base_id: "",
                    character_id: "",
                    character_name: "",
                    email: "",
                    question_type: "",
                    question_title: "",
                    question_content: ""
                },
                delFlag: {
                    p1: false,
                    p2: false,
                    p3: false
                },
                loadingFlag: {
                    p1: false,
                    p2: false,
                    p3: false
                },
                receiveKeyVal: {
                    p1: "",
                    p2: "",
                    p3: ""
                },
                canSubmit: false,
                reSubmit: true, // 防止连续点击提交按钮
                preId: ''
            };
        },
        components: {
            navbar,
            selectBox,
            inputBox
        },
        methods: {
            canI() {
                if (this.errorInfo.game_base_id == "" && this.errorInfo.character_id == "" && this.errorInfo.character_name == "" && this.errorInfo.question_type == "" && this.errorInfo.question_title == "" && this.errorInfo.question_content == "") {
                    if (this.$region == 'jp') {
                        this.canSubmit = true;
                    } else {
                        if (this.errorInfo.email == "") {
                            this.canSubmit = true;
                        }
                    }
                } else {
                    this.canSubmit = false;
                }
            },
            selectGameId(i) {
                this.formData.game_base_id = i;
                this.errorInfo.game_base_id = "";
            },
            selectType(i) {
                this.formData.question_type = i;
                this.errorInfo.question_type = "";
            },
            vartify(i, notice) {
                //notice == "no" 不显示报错信息
                // const contentMaxLength = this.globalLang === 'en' ? 2000 : 1000
                // const titleMinLenth = this.globalLang === 'en' ? 10 : 5
                // const titleMaxLenth = this.globalLang === 'en' ? 200 : 100
                // const characterNameMinLenth = this.globalLang === 'en' ? 1 : 1
                // const characterNameMaxLenth = this.globalLang === 'en' ? 40 : 20
                // const characterIdReg = this.globalLang === 'en' ? /^[A-Za-z\d]{10,40}$/ : /^[A-Za-z\d]{5,20}$/
                const contentMaxLength = 1000
                const titleMinLenth = 5
                const titleMaxLenth = 100
                const characterNameMinLenth = 1
                const characterNameMaxLenth = 20
                const characterIdReg = /^[A-Za-z\d]{5,20}$/

                let match = {
                    game_base_id: this.$t('service.choseGame'),
                    character_id: this.$t('service.require'),
                    character_name: this.$t('service.require'),
                    email: this.$t('service.require'),
                    question_type: this.$t('service.choseQuestionType'),
                    question_title: this.$t('service.require'),
                    question_content: this.$t('service.vaildQuestionContent')
                };
                if (!match[i]) {
                    this.canI();
                    return true;
                }
                if (i == "question_content") {
                    if (this.formData[i].length > contentMaxLength) {
                        this.errorInfo[i] = match[i];
                        this.canI();
                        return false;
                    } else {
                        this.errorInfo[i] = "";
                        this.canI();
                        return true;
                    }
                } else if (this.formData[i] == "") {
                    if (notice != "no") {
                        this.errorInfo[i] = match[i];
                    }
                    this.canI();
                    return false;
                }
                switch (i) {
                    case "email": {
                        // let eReg = /^[A-Za-z0-9._%-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,4}$/;
                        // 换为更为宽松的校验规则
                        let eReg = /^[A-Z a-z 0-9_.-]+@{1}[A-Z a-z 0-9_.-]+\.{1}[A-Z a-z 0-9_.-]+/;
                        if (!eReg.test(this.formData[i]) || this.formData[i].length > 50) {
                            if (notice != "no") {
                                this.errorInfo.email = this.$t('service.writeValidEmail');
                            }
                            this.canI();
                            return false;
                        } else {
                            this.errorInfo[i] = "";
                            this.canI();
                            return true;
                        }
                    }
                    case "question_title": {
                        let len = this.formData.question_title.length;
                        if (len < titleMinLenth || len > titleMaxLenth) {
                            if (notice != "no") {
                                this.errorInfo[i] = this.$t('service.vaildQuestionTitle');
                            }
                            this.canI();
                            return false;
                        } else {
                            this.errorInfo[i] = "";
                            this.canI();
                            return true;
                        }
                    }
                    case "character_id": {
                        if (!characterIdReg.test(this.formData.character_id)) {
                            if (notice != "no") {
                                this.errorInfo[i] = this.$t('service.vaildRoleId');
                            }
                            this.canI();
                            return false;
                        } else {
                            this.errorInfo[i] = "";
                            this.canI();
                            return true;
                        }
                    }
                    case "character_name": {
                        let l = this.formData.character_name.length;
                        if (l < characterNameMinLenth || l > characterNameMaxLenth) {
                            if (notice != "no") {
                                this.errorInfo[i] = this.$t('service.vaildRoleName');
                            }
                            this.canI();
                            return false;
                        } else {
                            this.errorInfo[i] = "";
                            this.canI();
                            return true;
                        }
                    }
                    default:
                        this.errorInfo[i] = "";
                        this.canI();
                        return true;
                }
            },
            uploadChange(e, key) {
                let file = e.target.files[0];
                let data = new FormData();
                data.append("file", file);
                data.append("size", file.size);
                if (!file.type || (file.type && file.type.indexOf('image') < 0)) {
                    alert(this.$t('service.uploadRightFile'));
                    return;
                }
                if (file.size / 1024 / 1024 > 5) {
                    alert(this.$t('service.vaildRecordSize'));
                    return;
                }
                this.loadingFlag[key] = true;
                this.$apis.service.upload({data: data, ct: this.$utils.token("joy_jct")})
                    .then(res => {
                        this.loadingFlag[key] = false;
                        if (res.data.code == 0) {
                            // 临时接收图片路径
                            this.receiveKeyVal[key] = res.data.data;
                        } else if (res.data.code == -1) {
                            alert(this.$t('service.vaildRecordSize'));
                        } else {
                            alert(res.data.message || this.$t('service.uploadPicError'));
                        }
                    })
                    .catch(() => {
                        this.loadingFlag[key] = false;
                        alert(this.$t('service.networkRequestError'));
                    });
            },
            submitForm() {
                if (this.reSubmit) {
                    // 有loading则不可点击提交
                    for (const key in this.loadingFlag) {
                        if (this.loadingFlag[key]) {
                            return false;
                        }
                    }
                    // 全部校验
                    for (const key in this.formData) {
                        if (!(this.$region === 'jp' && key === 'email')) {
                            this.vartify(key);
                        }
                    }
                    // 有错误提示则不可点击提交
                    for (const key in this.errorInfo) {
                        if (this.errorInfo[key] != "") {
                            this.canI();
                            return false;
                        }
                    }
                    for (const key in this.receiveKeyVal) {
                        if (this.receiveKeyVal[key] != "") {
                            this.formData.attachments.push(this.receiveKeyVal[key]);
                        }
                    }
                    // 防止连续点击提交按钮
                    this.reSubmit = false;
                    // 提交表单
                    this.$apis.service.newWordOrder(
                        "",
                        this.formData.game_base_id,
                        this.formData.character_id,
                        this.formData.character_name,
                        this.formData.email,
                        this.formData.question_type,
                        this.formData.question_title,
                        this.formData.question_content,
                        this.formData.source,
                        this.formData.attachments,
                        this.$utils.token("joy_jct")
                    )
                        .then(res => {
                            if (res.data.code == 0) {
                                this.formData = {
                                    game_base_id: "",
                                    character_id: "",
                                    character_name: "",
                                    email: this.formData.email,
                                    question_type: "",
                                    question_title: "",
                                    question_content: "",
                                    attachments: [],
                                    source: this.formData.source
                                };

                                this.reSubmit = true;
                                this.$router.push({
                                    name: 'servicePCOrderDetail',
                                    query: {id: res.data.data.work_order_id}
                                });
                            } else {
                                this.reSubmit = true;
                                alert(this.$t(`serviceCode.${res.data.code}`) || res.data.message || this.$t('service.submitFail'));
                            }
                        })
                        .catch(() => {
                            this.reSubmit = true;
                            alert(this.$t('service.requestError'));
                        });
                } else {
                    return false;
                }
            },
            delImg(i) {
                this.showImg = false;
                this.receiveKeyVal[i] = "";
            },
            showPreImg(i) {
                this.delFlag[i] = true;
                this.$refs.preImg.style.backgroundImage =
                    "url(" + this.receiveKeyVal[i] + ")";
                this.showImg = true;
            },
            closePreImg(i) {
                this.delFlag[i] = false;
                this.showImg = false;
                this.$refs.preImg.style.backgroundImage = "";
            },
            // 判断用户设备
            userAgent() {
                let u = navigator.userAgent;
                let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    this.formData.source = "Android";
                } else if (isiOS) {
                    this.formData.source = "iOS";
                } else {
                    this.formData.source = "web";
                }
            },
            // 切换导航栏
			changeTab(url) {
				this.$router.push({
						path: url
				});
			},
        },
        created () {
            // 获取游戏列表
            this.$apis.service.commonGameList().then(res => {
                if (res.data.code == 0) {
                    this.gameList = res.data.data.map(i => {
                        return {
                            id: i.game_base_id,
                            val: i.game_name
                        };
                    });
                }
            });
            // 获取问题类型列表
            this.$apis.service.commonQuestionTypeList().then(res => {
                if (res.data.code == 0) {
                    this.typeList = res.data.data.map(i => {
                        return {
                            id: i.question_type,
                            val: i.question_type_desc
                        };
                    });
                }
            });
            // 自动获取用户email
            this.$apis.service.getConnectInfo(this.$utils.token("joy_jct")).then(res => {
                if (res.data.code == 0) {
                    this.formData.email = res.data.data && res.data.data.email || "";
                }
            });
        },
        computed: {
            ...mapGetters(["userInfo"])
        },
        mounted () {
            // url中获取game_base_id参数
            this.formData.game_base_id = this.$route.query.game_base_id;
            // 判断用户设备
            this.userAgent();
        }
    };
</script>

<style lang="scss" scoped>
    /deep/ .bui-container-question {
        margin: 40px auto 0;
        width: 1170px;

        .select-box {
            width: 300px;
            height: 50px;
        }
        .bui-select {
            width: 100%;
        }

        &.en {
            .nick-box, .bui-select, .bui-box input, textarea {
                border-width: 1px;
            }
            .select-box{
                width: 600px;
            }
            .title {
                font-weight: bold;
            }
            .input-title {
                font-weight: bold;
            }
        }

        .remind1{
            width: 100%;
            border-radius: 8px;
            background: #eee;
            margin-bottom: 30px;
            color: #50BBE5;
            font-size: 16px;
            padding: 15px;
            box-sizing: border-box;
            line-height: 24px;
            &.remind2{
                color: #333;
                margin-bottom: 0;
            }
        }

        .notice {
            width: 100%;
            height: 60px;
            background: #fff4cd;
            border-radius: 6px;
            font-size: 0;

            img,
            span {
                display: inline-block;
                vertical-align: middle;
            }

            img {
                width: 16px;
                margin-left: 20px;
                margin-right: 10px;
            }

            span {
                font-size: 14px;
                line-height: 60px;
                color: #ffb13b;
                letter-spacing: 0;
            }
        }

        .title {
            margin: 30px auto 20px;
            display: inline-block;
            font-size: 16px;
            color: #444444;
            letter-spacing: 0;

            span {
                margin-left: 10px;
                font-size: 12px;
                color: #cccccc;
                letter-spacing: 0;
            }
        }

        .input-box {
            margin-top: 30px;

            span {
                margin-left: 10px;
                font-size: 12px;
                color: #ff5555;
                letter-spacing: 0;
            }
        }

        .error-info {
            margin-left: 10px;
            font-size: 12px;
            color: #ff5555;
            letter-spacing: 0;
        }

        .nick-box {
            width: 100%;
            height: 50px;
            color: #999999;
            background: #eeeeee;
            border: 2px solid #cccccc;
            border-radius: 100px;
            text-indent: 20px;
            box-sizing: border-box;
            user-select: none;
            outline: none;
        }

        textarea {
            display: block;
            width: 100%;
            padding: 16px 12px;
            box-sizing: border-box;
            line-height: 20px;
            background: #ffffff;
            border: 2px solid #cccccc;
            border-radius: 20px;
            font-size: 14px;
            color: #444444;
            height: 300px;
            resize: none;
            box-shadow: none;
            outline: none;
            -webkit-tap-highlight-color: transparent;
            -webkit-appearance: none;

            &:hover,
            &:focus {
                border-color: #50BBE5;
            }

            &.error {
                border-color: #ff5555;
            }
        }

        ::-webkit-input-placeholder {
            color: #cccccc;
        }

        hr {
            margin: 40px auto 40px;
            border: 0;
            height: 1px;
            background-color: #eeeeee;
        }

        .img-box {
            position: relative;
            font-size: 0;

            .big-img {
                position: absolute;
                top: -281px;
                left: 427px;
                width: 600px;
                height: 400px;
                background-color: #999999;
                background-position: center top;
                background-repeat: no-repeat;
                background-size: cover;
                border: 2px solid rgba(0, 0, 0, 0.3);
                border-radius: 10px;
                box-sizing: border-box;
            }
        }

        .imgInput {
            position: relative;
            margin-right: 30px;
            display: inline-block;
            width: 119px;
            height: 119px;
            vertical-align: top;

            .previewImg {
                position: relative;
                width: 100%;
                height: 100%;
                overflow: hidden;
                border-radius: 20px;
                background-color: #999999;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                cursor: pointer;

                .btn-del {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    border-radius: 20px;
                    box-sizing: border-box;
                    user-select: none;

                    img {
                        position: absolute;
                        width: 36px;
                        height: 36px;
                        top: 50%;
                        left: 50%;
                        margin-top: -18px;
                        margin-left: -18px;
                    }
                }

                &.on .btn-del {
                    background: rgba(0, 0, 0, 0.7);
                    border: 2px solid #50BBE5;
                }
            }

            .file_btn {
                width: 100%;
                height: 100%;
                overflow: hidden;
                background-image: url("../images/addpic.svg");
                background-position: center center;
                background-repeat: no-repeat;
                background-size: contain;

                &:hover {
                    background-image: url("../images/addpic_hover.svg");
                }

                input {
                    display: block;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    cursor: pointer;
                }

                .loadingImg {
                    position: absolute;
                    width: 36px;
                    height: 36px;
                    top: 50%;
                    left: 50%;
                    margin-top: -18px;
                    margin-left: -18px;
                    border-radius: 50%;
                    background: url(../images/loading_small.svg) center center no-repeat;
                    background-size: contain;
                    background-color: #ffffff;
                    animation: roll 1s infinite;
                }
            }
        }

        .btn-submit {
            margin: 0 auto 120px;
            width: 300px;
            height: 60px;
            background-color: #cccccc;
            border-radius: 100px;
            font-size: 16px;
            line-height: 60px;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
            user-select: none;
            cursor: not-allowed;
        }

        .btn-submit.active {
            background-color: #50BBE5;
            cursor: pointer;

            &:hover {
                box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
            }
        }
    }

    @keyframes roll {
        from {
            transform: rotateZ(0);
        }
        to {
            transform: rotateZ(360deg);
        }
    }
</style>

<style lang="scss">
.jp {
    input, .bui-select, textarea {
        border-width: 1px!important;
    }
}
</style>